/* User-initiated bridge to the existing Loox onsite referral sidebar.
   The observed provider button opens registration; this never submits it.
   Provider context: https://help.loox.io/article/598-onsite-referrals */
(() => {
  const trigger = document.querySelector('[data-hsf-open-referrals]');
  const status = document.getElementById('hsf-referral-status');
  if (!trigger || trigger.dataset.hsfReferralBound) return;
  trigger.dataset.hsfReferralBound = 'true';
  trigger.addEventListener('click', () => {
    const providerButton = document.getElementById('loox-visitor-level-referral-btn');
    if (providerButton && typeof providerButton.click === 'function') {
      if (status) status.textContent = '';
      providerButton.click();
      return;
    }
    if (status) {
      status.replaceChildren(document.createTextNode('Referral signup is still loading. Please try again in a moment, or '));
      const help = document.createElement('a');
      help.href = '/pages/contact-us';
      help.textContent = 'contact our team';
      status.append(help, document.createTextNode(' for help.'));
    }
  });
})();
